<template>

  <v-container>
    <h1 class="text-center" v-if="loading">
      Chargement de la boutique
      <p class="font-weight-light">Merci de patienter quelques secondes.</p>
    </h1>
    <br/>
    <div ref="store" class="my-7"/>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    loading: true,
    instanceId: 'my-store-'+(new Date()).getTime()+'-'+Math.random().toString(36).slice(2,10)
  }),
  mounted() {
    if (typeof Ecwid !== 'undefined') {
      window.location = '/shop'
      return
    }

    this.$refs.store.id = this.instanceId
    const self = this
    let scriptLoader = document.createElement('script')
    scriptLoader.charset = 'utf-8'
    scriptLoader.src = 'https://app.ecwid.com/script.js?13907026&data_platform=code&data_date=2020-05-13'
    scriptLoader.onload = function () {
      xProductBrowser("categoriesPerRow=3","views=grid(20,3) list(60) table(60)","categoryView=grid","searchView=list","id="+self.instanceId)
  
      __openPage(self)
      
      Ecwid.OnPageLoaded.add(function (page) {
        if (page.type === 'ORDER_CONFIRMATION') {
          __saveProject(page)
        }
      })

      document.body.removeChild(scriptLoader)
    }
    scriptLoader.onerror = function () {
      console.log('error')
    }
    document.body.appendChild(scriptLoader)
  }
}

function __openPage (self) {
  if (typeof Ecwid.openPage === 'undefined') {
    setTimeout(() => __openPage(self), 50)
  } else {
    self.loading = false

    // const page = {"type":"ORDER_CONFIRMATION","orderNumber":112,"vendorOrderNumber":"1811201","orderId":129863589,"hasPrevious":true}
    // __saveProject(page)
          
    setTimeout(() => Ecwid.openPage('product', { id: '107281518' }), 150)
  }
}

function __saveProject (page) {
  let returnVal = {}
  const formStr = localStorage.getItem('form-done')
  try { returnVal = JSON.parse(formStr) } catch (e) {console.error(e)}
  
  axios.post(process.env.VUE_APP_BASE_URL+'/api/project/new', {
    formStr: formStr,
    form: returnVal,
    orderNumber: ''+page.orderNumber,
    vendorOrderNumber: ''+page.vendorOrderNumber,
    orderId: ''+page.orderId
  })
  .then(function (response) {
    console.log(response)
  })
  .catch(function (error) {
    console.log(error)
  })
}

</script>

